import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { DemoDashboardWrapper } from '../pages/demo-dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import { StatisticsAdmin } from '../modules/apps/statistics/StatisticsAdmin'
import { StatisticsUser } from '../modules/apps/statistics/StatisticsUser'

const PrivateRoutes = () => {
    const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
    const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
    const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
    const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
    const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
    const ContactsPage = lazy(() => import('../modules/apps/contact-management/ContactsPage'))
    const ThemeAdminPage = lazy(
        () => import('../modules/apps/theme-management/admin/ThemeAdminPage')
    )
    const ThemeUserPage = lazy(() => import('../modules/apps/theme-management/user/ThemeUserPage'))
    const GenerateQr = lazy(() => import('../modules/apps/generate-qr/GenerateQrPage'))

    return (
        <Routes>
            <Route element={<MasterLayout />}>
                {/* Redirect to Dashboard after success login/registartion */}
                <Route path='auth/*' element={<Navigate to='/dashboard' />} />
                {/* Pages */}
                <Route
                    path='dashboard/*'
                    element={
                        <SuspensedView>
                            <ContactsPage />
                        </SuspensedView>
                    }
                />
                <Route path='demo/dashboard' element={<DemoDashboardWrapper />} />
                <Route path='builder' element={<BuilderPageWrapper />} />
                <Route path='menu-test' element={<MenuTestPage />} />
                {/* Lazy Modules */}
                <Route
                    path='crafted/pages/profile/*'
                    element={
                        <SuspensedView>
                            <ProfilePage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='crafted/pages/wizards/*'
                    element={
                        <SuspensedView>
                            <WizardsPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='crafted/widgets/*'
                    element={
                        <SuspensedView>
                            <WidgetsPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='crafted/account/*'
                    element={
                        <SuspensedView>
                            <AccountPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/user-management/*'
                    element={
                        <SuspensedView>
                            <UsersPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/theme-management/admin/*'
                    element={
                        <SuspensedView>
                            <ThemeAdminPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/theme-management/user/*'
                    element={
                        <SuspensedView>
                            <ThemeUserPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/statistics/user'
                    element={
                        <SuspensedView>
                            <StatisticsUser />
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/statistics/admin'
                    element={
                        <SuspensedView>
                            <StatisticsAdmin />
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/generate-qr'
                    element={
                        <SuspensedView>
                            <GenerateQr />
                        </SuspensedView>
                    }
                />
                {/* Page Not Found */}
                <Route path='*' element={<Navigate to='/error/404' />} />
            </Route>
        </Routes>
    )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
    const baseColor = getCSSVariableValue('--kt-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
